import { useContext } from "react";
import { RoomContext } from "../RoomContext";
import useParticipants from "./useParticipants";

export const useMainParticipant = () => {
  const { room } = useContext(RoomContext);
  const participants = useParticipants();

  return participants.length > 1 ? participants[0] : room.localParticipant;
};
